import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ReactComponent as InstallToWorkspace } from 'assets/images/install.svg';
import LoginViaSlack from 'assets/images/usingSlack.svg';
import LoginViaTeams from 'assets/images/usingTeams.svg';
import styles from './styles.module.scss';

const getData = (queryParams) => {
  const params = new URLSearchParams(queryParams);
  let queryString = {};
  const redirect = params.get('redirect');
  if (!redirect) {
    return {};
  }
  // eslint-disable-next-line no-restricted-syntax
  for (const key of params.keys()) {
    if (!['redirect', 'platform'].includes(key)) {
      queryString[key] = params.get(key);
    }
  }

  queryString = new URLSearchParams(queryString);
  queryString = queryString.toString();

  return {
    redirect: `?redirect=${redirect}&${queryString}`,
    platform: params.get('platform') || 'all'
  };
};

const Login = (props) => {
  const {
    location: { search }
  } = props;
  const { redirect = '', platform = 'all' } = getData(search);

  return (
    <div className={styles.loginContainer}>
      <div className={styles.image}>
        <InstallToWorkspace />
      </div>
      <div data-testid='login' className={styles.header}>
        Login to Trivia
      </div>
      <Grid
        container
        alignItems='center'
        alignContent='center'
        direction='row'
        className={styles.wrapper}
        spacing={2}
      >
        {['all', 'slack'].includes(platform) && (
          <Grid
            item
            className={styles.wrapperSlack}
            onClick={() => window.open(process.env.REACT_APP_SLACK_LOGIN + redirect, '_self')}
          >
            <img className={styles.img} src={LoginViaSlack} alt='Login with Slack' />
          </Grid>
        )}
        {['all', 'teams'].includes(platform) && (
          <Grid
            item
            className={styles.wrapperTeams}
            onClick={() => window.open(process.env.REACT_APP_TEAMS_LOGIN + redirect, '_self')}
          >
            <img className={styles.img} src={LoginViaTeams} alt='Login with Teams' />
          </Grid>
        )}
      </Grid>
    </div>
  );
};
Login.propTypes = {
  location: PropTypes.objectOf(PropTypes.string).isRequired
};

export default Login;
